angular.module('admin.subscriptions').controller('TrialCtrl',
    function ($http, $uibModalInstance, Upload, config, TrialPlans) {


        this.viewMode = 'upload';

        this.steps = [];

        this.upload = {
            planId: 2
        }

        this.hasNext = function () {

            switch (this.viewMode) {
                case 'success': return false;
                case 'summary': return this.summary.successful > 0;
                case 'upload': return Boolean(this.upload.file);
            }

            return true;
        }

        this.next = function () {
            var me = this;
            switch (this.viewMode) {

                case 'upload':
                    this.processing = true;

                    this.import().then((response) => {
                        me.summary = response.data;
                        me.summary.selectedPlan = me.plans.find(p => p.id === me.upload.planId);
                        me.processing = false;
                        me.advanceStep('summary');

                    }, () => {

                    })
                    break;
                case 'summary':{
                    me.processing = true;
                    this.complete().then(() => {
                        me.processing = false;
                        me.advanceStep('success');
                    }, e=> {
                        me.processing = false;
                    })
                    break;
                }
            }
        }

        this.advanceStep = function (newStep) {
            this.viewMode = newStep;
            this.steps.push(this.viewMode);
        }

        this.previous = function () {
            this.steps.splice(this.steps.length - 1, 1);
            this.viewMode = this.steps[this.steps.length - 1];
        }

        this.dismiss = function () {
            $uibModalInstance.dismiss();
        }

        this.close = function () {
            $uibModalInstance.close();
        }


        this.selectFile = function (file) {
            this.upload.file = file;
        }

        this.import = function () {

            var req = {
                url: config.api + '/api/AdminTrial/Upload',
                method: 'POST',
                data: {
                    planId: this.upload.planId
                },
                file: this.upload.file
            };
            return Upload.upload(req);
        }


        this.exportToExcel = function () {

            var date = new Date;
            

            var filename = `Planilha_${date.valueOf()}.xlsx`;
            this.isExporting = true;
            $http({
                url: config.api + '/api/AdminTrial/Export',
                method: 'GET',
                responseType: 'arraybuffer'
            }).then((res) => {
                this.isExporting = false;
                res.headers();
                var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.target = '_blank';
                a.click();
            }, () => {
                this.isExporting = false;
            });
        }
        this.complete = function () {

            
            return $http({
                url: config.api + '/api/AdminTrial/Complete',
                method: 'POST',
                params: {
                    planId: this.upload.planId
                }
            });
        }


        this.init = function () {

            this.steps.push(this.viewMode);

            TrialPlans.query(p => {
                this.plans = p;
            });
        }

        this.init();
    });